import { AuthUser } from '../types/api';

/** Full name if set, else first + last, else the email's local part. */
export function displayName(user: AuthUser): string {
  return user.full_name || `${user.first_name} ${user.last_name}`.trim() || user.email.split('@')[0];
}

/** Up to two initials for an avatar. */
export function initialsOf(user: AuthUser): string {
  return displayName(user)
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join('');
}
